module.exports = __webpack_public_path__ + "media/images/menu/m12-b948d36c676f9344328c0a78c25d59ae.JPG";